import { createEntityAdapter } from '@reduxjs/toolkit';
import { t } from 'i18next';

import { State } from 'Libs/redux/types';

import { ContentEntity } from '../content.types';

export const contentAdapter = createEntityAdapter<ContentEntity>({});

export const {
  selectAll,
  selectById: selectByIdFromAdapter,
  selectEntities,
  selectIds,
  selectTotal,
} = contentAdapter.getSelectors();

export const selectById = (contentId?: number | null) => (state: State) =>
  contentId ? selectByIdFromAdapter(state.entities.content, contentId) : null;

export const contentMetadataSelector = (state: State) => state.entities.content.metadata;

export const selectLastContribution = (content?: Partial<ContentEntity> | null) => {
  if (!content || !content?.contributions || content.contributions.length === 0) return '';

  const date = new Date(content.contributions[content.contributions.length - 1].date);

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  const now = new Date();

  if (now.getDate() === day && now.getMonth() + 1 === month && now.getFullYear() === year) {
    return `${t('contents:content_details.saved.last_saved_at')} ${date.getHours()}:${date.getMinutes()}`;
  }

  return t('contents:content_details.saved.last_saved_date_time', {
    date: `${day}/${month}/${year}`,
    time: `${date.getHours()}:${date.getMinutes()}`,
  });
};
